import { LuminaQualification } from '@luminalearning/types';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import AppCard from 'src/Components/Apps/AppCard';
import env from 'src/env/index';

type Props = {
    isLoading: boolean
    productQualifications?: LuminaQualification[]
};

const ShortcutRows = (props: Props) => {
    const { isLoading, productQualifications } = props;
    const [selectLink, setSelectLink] = useState<string | null>(null);

    useEffect(() => {
        if (isLoading) return;
        if (!productQualifications) return;
        const isSelectQualified = productQualifications.find((x) => x.qualificationName === 'SelectV2');

        if (isSelectQualified) {
            setSelectLink(`${env.luminaAtsUrl}`);
        } else {
            setSelectLink(`${env.luminaLearningUlr}products/lumina-select/`);
        }
    }, [productQualifications, isLoading]);

    const intl = useIntl();
    return (
        <>
            <div className='mt-16 flex justify-center xl:justify-start'>
                <a href='/products'>
                    <span className='text-headline-reg font-bold'>
                        {
                            intl.formatMessage({
                                id: 'LP_LUMINA_SHORTCUTS',
                                defaultMessage: 'Shortcuts',
                            })
                        }
                    </span>
                </a>
            </div>
            <section className='flex flex-wrap flex-col md:flex-row sm:justify-center
                md:justify-center xl:justify-start mr-2 items-center'>
                {/* Lumina Team shortuct */}
                <AppCard
                    appName={
                        intl.formatMessage({
                            id: 'LP_LUMINA_TEAMS',
                            defaultMessage: 'Lumina Team',
                        })
                    }
                    appLogo={<img src={'/img/lumina-team-logo.png'} alt={
                        intl.formatMessage({
                            id: 'LP_LUMINA_TEAMS',
                            defaultMessage: 'Lumina Team',
                        })
                    } />}
                    body={
                        intl.formatMessage({
                            id: 'LP_LUMINA_TEAMS_DESC',
                            defaultMessage: 'See an holistic view of a team’s personality dynamics',
                        })
                    }
                    link={`${env.luminateamsUrl}`}
                    isLoading={isLoading}
                />

                <AppCard
                    appName={
                        intl.formatMessage({
                            id: 'LP_SPARK_EXPLAINER',
                            defaultMessage: 'Lumina Spark Explainer',
                        })
                    }
                    appLogo={<img src={'/img/spark-explainer.png'} alt={
                        intl.formatMessage({
                            id: 'LP_SPARK_EXPLAINER',
                            defaultMessage: 'Lumina Spark Explainer',
                        })
                    } />}
                    body={
                        intl.formatMessage({
                            id: 'LP_SPARK_EXPLAINER_DESC',
                            defaultMessage: 'A short introduction to the Lumina Spark Model',
                        })
                    }
                    link={`${env.luminaLearningUlr}/spark-explainer/`}
                    internalLink={false}
                    isLoading={isLoading}
                />
                <AppCard
                    appName={
                        intl.formatMessage({
                            id: 'LP_SPARKING_UP_YOUR_WORKSHOP',
                            defaultMessage: 'Sparking Up Your Workshop',
                        })
                    }
                    appLogo={<img src={'/img/InPerson.png'} alt={
                        intl.formatMessage({
                            id: 'LP_SPARKING_UP_YOUR_WORKSHOP',
                            defaultMessage: 'Sparking Up Your Workshop',
                        })
                    } />}
                    body={
                        intl.formatMessage({
                            id: 'LP_SPARKING_UP_YOUR_WORKSHOP_EXPLAIN',
                            defaultMessage: 'A fully comprehensive guide for how to run the best workshops',
                        })
                    }
                    link='/spark-up-your-workshop'
                    internalLink={true}
                    isLoading={isLoading}
                />
                <AppCard
                    appName={
                        intl.formatMessage({
                            id: 'LP_SPARKING_UP_YOUR_COACHING',
                            defaultMessage: 'Sparking Up Your Coaching',
                        })
                    }
                    appLogo={<img src={'/img/Coaching.png'} alt={
                        intl.formatMessage({
                            id: 'LP_SPARKING_UP_YOUR_COACHING',
                            defaultMessage: 'Sparking Up Your Coaching',
                        })
                    } />}
                    body={
                        intl.formatMessage({
                            id: 'LP_SPARKING_UP_YOUR_COACHING_EXPLAIN',
                            defaultMessage: 'How to best utilise Lumina Spark in your coaching practice',
                        })
                    }
                    link='/spark-up-your-coaching'
                    internalLink={true}
                    isLoading={isLoading}
                />

                <AppCard
                    appName={
                        intl.formatMessage({
                            id: 'LP_SPARK_COACH',
                            defaultMessage: 'Spark Coach',
                        })
                    }
                    appLogo={<img src={'/img/SparkCoachIcon@.png'} alt={
                        intl.formatMessage({
                            id: 'LP_SPARK_COACH',
                            defaultMessage: 'Spark Coach',
                        })
                    } />}
                    body={
                        intl.formatMessage({
                            id: 'LP_SPARK_COACH_EXPLAIN',
                            defaultMessage: 'Continue learning beyond your workshops',
                        })
                    }
                    link={`${env.luminaELearingsUrl}/storyline/demo/spark-coach`}
                    isLoading={isLoading}
                />

                <AppCard
                    appName={
                        intl.formatMessage({
                            id: 'LP_SPARK_COACH_PLUS',
                            defaultMessage: 'Spark Coach Plus',
                        })
                    }
                    appLogo={<img src={'/img/SparkCoachPlusIcon.png'} alt={
                        intl.formatMessage({
                            id: 'LP_SPARK_COACH_PLUS',
                            defaultMessage: 'Spark Coach Plus',
                        })
                    } />}
                    body={
                        intl.formatMessage({
                            id: 'LP_SPARK_COACH_EXPLAIN_PLUS',
                            defaultMessage: 'All the depth of both Lumina Spark and Lumina Emotion all rolled into one',
                        })
                    }
                    link={`${env.luminaELearingsUrl}/storyline/demo/spark-coach-plus`}
                    isLoading={isLoading}
                />

                <AppCard
                    appName={
                        intl.formatMessage({
                            id: 'LP_LUMINA_SELECT',
                            defaultMessage: 'Lumina Select',
                        })
                    }
                    appLogo={<img src={'/img/lumina-select-logo-blue.png'} alt={
                        intl.formatMessage({
                            id: 'LP_LUMINA_SELECT',
                            defaultMessage: 'Lumina Select',
                        })
                    } />}
                    body={
                        intl.formatMessage({
                            id: 'LP_LUMINA_SELECT_DESC',
                            defaultMessage: 'Our selection solution, match the right people to the right jobs',
                        })
                    }
                    link={selectLink || ''}
                    isLoading={selectLink === null}
                />
                <AppCard
                    appName={
                        intl.formatMessage({
                            id: 'LP_SELECT_CARD_SORT',
                            defaultMessage: 'Select Card Sort',
                        })
                    }
                    appLogo={<img src={'/img/SelectCardSortIcon.png'} alt={
                        intl.formatMessage({
                            id: 'LP_SELECT_CARD_SORT',
                            defaultMessage: 'Select Card Sort',
                        })
                    } />}
                    body={
                        intl.formatMessage({
                            id: 'LP_SELECT_CARD_SORT_DESC',
                            defaultMessage: 'Identify which Competencies are most important for a role',
                        })
                    }
                    link={`${env.luminaELearingsUrl}/card-sort/practitioner`}
                    isLoading={isLoading}
                />
            </section>
        </>

    );
};

export default ShortcutRows;